<template>
  <div class="document-config">
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form" size="small">
      <el-form-item prop="userId">
        <el-input clearable v-model="searchForm.userId" placeholder="会员ID" />
      </el-form-item>
      <el-form-item prop="payType">
        <el-select placeholder="支付方式" size="small" clearable
                   style="margin-left:15px;" v-model="searchForm.payType">
          <el-option :value="1" label="微信">微信</el-option>
          <el-option :value="2" label="支付宝">支付宝</el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('searchForm')">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="table-container">
      <div class="table-header">
        <p class="total-count">总数: {{ total }}</p>
      </div>
      <el-table class="table-list" :data="tableData" border :stripe="true" :show-overflow-tooltip="true">
        <el-table-column type="index" align="center" label="序号" />
        <el-table-column align="center" prop="userId" label="会员ID" width="80" />
        <el-table-column align="center" prop="id" label="订单编号" width="160" />
        <el-table-column align="center" prop="payAmount" label="实付金额" />
        <el-table-column align="center" prop="packagePayAmount" label="订单金额" />
        <el-table-column align="center" prop="packageAmount" label="算力价值" />
        <el-table-column align="center" prop="inviteUserId" label="邀请会员ID" />
        <el-table-column align="center" prop="teamId" label="团队会员ID" />
        <el-table-column align="center" prop="finishTime" label="完成时间" />
        <el-table-column align="center" prop="payTime" label="支付时间" />
        <el-table-column align="center" prop="payTimeout" label="支付超时时间" />
        <el-table-column align="center" prop="transactionId" label="微信支付订单号" />
        <el-table-column align="center" prop="payTypeName" label="支付方式" />
        <el-table-column align="center" prop="packageTypeName" label="状态" width="100" />
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="footer">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="searchForm.size"
        @current-change="handleCurrentChange"
        @size-change="onChangeSize"
        :current-page="searchForm.current"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {changeOrderPackageType, getOrderPackageList} from "@/api/orderPackage";

export default {
  data() {
    return {
      searchForm: {
        userId: null,
        payType: null,
        current: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.getDataList();
    },

    async getDataList() {
      try {
        let res = await getOrderPackageList(this.searchForm);
        if (res.code == 200) {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },

    changeStatus(row) {
      this.$confirm(`确认修改状态吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(async () => {
            let packageType = row.packageType;
            if (packageType == 0 || packageType == 3) {
              this.$message.error("该订单不能修改状态");
              return;
            }
            let type;
            if (packageType < 6) {
              type = 6;
            } else {
              type = 7;
            }
            changeOrderPackageType({id: row.id, type: type}).then(res => {
              if (res.code == 200) {
                this.getDataList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作"
            });
          });
    },

    // 查询
    handleQuery() {
      this.searchForm.current = 1;
      this.getDataList();
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.searchForm.current = 1;
      this.getDataList();
    },

    // 页码改变
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getDataList();
    },

    // 每页条数改变
    onChangeSize(val) {
      this.searchForm.size = val;
      this.searchForm.current = 1;
      this.getDataList();
    },

  }
};
</script>

<style lang="scss" scoped>
.document-config {
  padding: 20px;
}

.table-container {
  padding: 10px 20px 20px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 72px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .total-count {
    font-size: 18px;
    font-weight: 600;
  }
}

.table-list {
  font-size: 12px;

  .content {
    // 超出部分省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.footer {
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 100;
  padding: 20px;
  box-shadow: 0 -8px 8px -10px rgba(0, 0, 0, 0.2);
  /* 顶部外阴影 */

  .pagination {
    text-align: right;
    padding: 0;
  }
}
</style>
